import _ from 'lodash';
window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });

// Amplify v5 (ESM friendly)
import { Amplify } from 'aws-amplify';
import { PubSub, AWSIoTProvider } from '@aws-amplify/pubsub';

if (import.meta.env.DEV) window.LOG_LEVEL = 'DEBUG';

Amplify.configure({
  Auth: {
    identityPoolId: import.meta.env.VITE_AWS_IDENTITY_POOL_ID,
    region: import.meta.env.VITE_AWS_REGION,
  },
});

Amplify.addPluggable(new AWSIoTProvider({
  aws_pubsub_region: import.meta.env.VITE_AWS_REGION,
  aws_pubsub_endpoint: import.meta.env.VITE_AWS_IOT_ENDPOINT,
}));

window.PubSub = PubSub;
window.Amplify = Amplify;
